import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { HttpService } from './http.service';

@Injectable()
export class HrccService {

  public sickLeave = null;

  constructor(public httpService: HttpService) {
  }

  public getIrregularityByAbsenceId(absenceID: string, employeeID: string) {
    const body = {
      'appLang': 'fr',
      'absenceID': absenceID,
      'employeeID': employeeID
    };
    return this.httpService.post('/hradmin/getAbsenceById', body)
  }

  public getEmployeeByEmployeeId(empId: string) {
    const body = {
      'appLang': 'fr',
      'employeeID': empId
    };
    return this.httpService.post('/hradmin/getEmployeeDetailsHra', body)
  }

  public getLinkedLeaves(certificateID, absenceID) {
    const body = {
      'appLang': 'fr',
      'certificateID': certificateID,
      'absenceID': absenceID,
    }
    return this.httpService.post('/hradmin/getAbsencesByCertID', body);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/hrcc.service.ts